export const ContractsActionTypes = {
    GET_SETTLEMENT_LIST: 'domain/contracts/get_settlement_list',
    SET_SETTLEMENT_LIST: 'domain/contracts/set_settlement_list',
    SET_SETTLEMENT_LIST_COUNT: 'domain/contracts/set_settlement_list_count',
    SET_SETTLEMENT_CURRENT_PAGE: 'domain/contracts/set_settlement_current_page',
};
